import { useEffect } from 'react';
import { useFramework } from '@/framework';
import { type CropBackground } from '../crop-background';
import CropBackgroundOperate from './crop-background-operate';
import CropBackgroundToolbar from './crop-background-toolbar';

const CropBackgroundWrap: React.FC = () => {
    const framework = useFramework();
    const cropBackground = framework.service.registration.getInstance<CropBackground>('CropBackground');

    useEffect(() => {
        const handlers = [
            // 激活舞台变化时，取消裁剪
            framework.service.frame.onActiveIndexChange(() => {
                cropBackground.cancel();
            }),
        ];

        return () => {
            handlers.forEach((handler) => {
                framework.service.events.off(handler);
            });
        };
    }, []);

    return (
        <>
            <CropBackgroundOperate />
            <CropBackgroundToolbar />
        </>
    );
};

export default CropBackgroundWrap;
